import React from 'react';

import Store from 'RLX/State/Store';
import { loadSite } from 'RLX/State/Content/ContentActions';
import { startLoading, finishLoading } from 'RLX/State/Ui/UiActions';

class AppController extends React.Component {
  constructor (props) {
    super(props);
    this.state = Store.getState();
    if (!this.state.ui.initialStateLoaded && this.state.auth.loggedIn) {
      startLoading();
      loadSite().then(() => finishLoading());
    }
  }

  componentDidMount () {
    this.unsubscribe = Store.subscribe(() => {
      const state = Store.getState();
      this.setState(state);
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  getPages () {
    const { pages } = this.state.siteData;
    if (!Array.isArray(pages))
      throw new TypeError('Invalid siteData.pages (expected array)');
    return pages;
  }

  getPageByUrl (_url) {
    return this
      .getPages()
      .find(({ url }) => url === _url);
  }

  getPageIndexByUrl (_url) {
    return this
      .getPages()
      .findIndex(({ url }) => url === _url);
  }

  getPageById (_id) {
    return this
      .getPages()
      .find(({ id }) => id === _id);
  }

  getPageIndexById (_id) {
    return this
      .getPages()
      .findIndex(({ id }) => id === _id);
  }

  getBlogs () {
    const { blogs } = this.state.siteData;
    if (!Array.isArray(blogs))
      throw new TypeError('Invalid siteData.pages (expected array)');
    return blogs;
  }

  getBlogById (_id) {
    return this
      .getBlogs()
      .find(({ id }) => id === _id);
  }
};

export default AppController;



// WEBPACK FOOTER //
// ./client/RLX/Controllers/AppController.jsx